"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user.list': 'Users',
    'route.user.create': 'Add User',
    'route.user.edit': 'Edit User',
};
